export const faqItems = [
  {
    question: 'What is VigorBuy Spreadsheet?',
    answer:
      'VigorBuy Spreadsheet is a resource system that organizes product information into easy-to-understand lists and guides, helping shoppers discover and compare items across multiple categories including shoes, clothing, accessories, and more. The spreadsheet format makes it simple to view product details at a glance without needing to search through scattered information.',
  },
  {
    question: 'Is VigorBuy Spreadsheet free to use?',
    answer:
      'Many spreadsheet resources and product guides are accessible online at no cost. Users should always verify the authenticity of any resource before relying on its information, and check that product links and pricing details are current.',
  },
  {
    question: 'How often is VigorBuy Spreadsheet updated?',
    answer:
      'Updates to the VigorBuy Spreadsheet resources depend on the availability of new product information and catalog changes. We recommend checking back regularly to access the most current product lists and comparison data available for the 2026 shopping season.',
  },
  {
    question: 'Is VigorBuy Spreadsheet safe to use?',
    answer:
      'While VigorBuy Spreadsheet resources help organize product research, users should always follow standard online safety practices. This includes checking website authenticity, avoiding suspicious links, protecting personal and payment information, and reviewing product details carefully before making any purchasing decisions.',
  },
  {
    question: 'What product categories are available in the spreadsheet?',
    answer:
      'VigorBuy Spreadsheet covers a wide range of product categories including Shoes, Hoodies and Sweaters, T-Shirts, Jackets, Pants and Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and other miscellaneous items. Each category features organized product listings for easy browsing.',
  },
  {
    question: 'Can I compare products using VigorBuy Spreadsheet?',
    answer:
      'Yes, one of the key benefits of VigorBuy Spreadsheet is its comparison-friendly structure. The organized format allows users to view multiple products side by side, helping them evaluate features, categories, and options before making informed shopping decisions.',
  },
  {
    question: 'How do I start using VigorBuy Spreadsheet?',
    answer:
      'Getting started is straightforward. Begin by selecting a product category that interests you, browse the organized listing to compare available options, and use the information to make more informed purchasing choices. The beginner-friendly layout is designed to be intuitive for all users.',
  },
];